import {Component, ViewEncapsulation, HostListener, OnInit, AfterViewInit, OnChanges, SimpleChanges, Input} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import {HttpErrorResponse} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {TranslateService} from "@ngx-translate/core";
import {SharedDataService} from "../../services/shared-data.service";
import {MenuService} from "../../../components/security/services/menu.service";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit, OnChanges  {
  public userMenus: any[];

  public iconSidebar;

  public userLayout = localStorage.getItem('layout');
  public checkProfile: string;

  @Input()
  public menuItems: Menu[];
    public userPermissions = [];



      public menus = [

          // Security module
          this.translate.instant('profile'),
          this.translate.instant('user'),
          this.translate.instant('institution'),
          this.translate.instant('branch'),
          this.translate.instant('session'),
          this.translate.instant('year'),
          this.translate.instant('current year'),
          this.translate.instant('system settings'),

          // Setting
          this.translate.instant('human resource'),
          this.translate.instant('employment status'),
          this.translate.instant('leave character'),
          this.translate.instant('leave type'),

          this.translate.instant('institution'),
          this.translate.instant('ministry'),
          this.translate.instant('manager type'),

          this.translate.instant('location'),
          this.translate.instant('country'),
          this.translate.instant('region'),

          this.translate.instant('person'),
          this.translate.instant('blood group'),
          this.translate.instant('civility'),
          this.translate.instant('rhesus'),
          this.translate.instant('sex'),
          this.translate.instant('religion'),
          this.translate.instant('identity type'),
          this.translate.instant('marital status'),
          this.translate.instant('person type'),

          this.translate.instant('diploma type'),
          this.translate.instant('repeating'),
          this.translate.instant('subject nature'),
          this.translate.instant('period type'),

          // Treasury module
          this.translate.instant('cash desk'),
          this.translate.instant('cash desk operation'),
          this.translate.instant('bank'),
          this.translate.instant('bank account'),
          this.translate.instant('bank account operation'),
          this.translate.instant('budget operation'),
          this.translate.instant('expense operation'),

          // Budget module
          this.translate.instant('exercise'),
          this.translate.instant('manager'),
          this.translate.instant('budget level'),
          this.translate.instant('budget section'),
          this.translate.instant('budget nature'),
          this.translate.instant('budget heading'),
          this.translate.instant('budget line'),
          this.translate.instant('budget'),
          this.translate.instant('budget review'),
          this.translate.instant('budget transaction'),

          // Product module
          this.translate.instant('configuration'),
          this.translate.instant('fee payment scheme'),
          this.translate.instant('fee type'),
          this.translate.instant('unit category'),
          this.translate.instant('unit'),
          this.translate.instant('attribute'),
          this.translate.instant('attribute value'),
          this.translate.instant('billing policy'),
          this.translate.instant('cost strategy'),
          this.translate.instant('subtract strategy'),
          this.translate.instant('item type'),
          this.translate.instant('item category'),

          this.translate.instant('fee'),
          this.translate.instant('fee installment'),

          this.translate.instant('item'),
          this.translate.instant('packaging'),

          // Inventory module
          this.translate.instant('warehouse'),
          this.translate.instant('location'),
          this.translate.instant('stock'),
          this.translate.instant('stock movement'),
          this.translate.instant('delivery'),
          this.translate.instant('reception'),
          this.translate.instant('transfer'),
          this.translate.instant('inventory'),
          this.translate.instant('zone'),
          this.translate.instant('inventory item'),

          // Sale module
          this.translate.instant('sale invoice'),
          this.translate.instant('sale return invoice'),
          this.translate.instant('settlement'),
          this.translate.instant('rental'),

          // Purchase module
          this.translate.instant('purchase invoice'),
          this.translate.instant('purchase return invoice'),
          this.translate.instant('settlement'),

          // Partner module
          this.translate.instant('partner category'),
          this.translate.instant('supplier'),
          this.translate.instant('customer'),
          this.translate.instant('contact'),

          // Pos module
          this.translate.instant('pos setting menu'),
          this.translate.instant('coin bill'),
          this.translate.instant('model note'),
          this.translate.instant('room'),
          this.translate.instant('room plan'),
          this.translate.instant('table'),
          this.translate.instant('pos setting sub menu'),
          this.translate.instant('pos view'),
          this.translate.instant('pos'),

          // Employee module
          this.translate.instant('employee module'),
          this.translate.instant('employee'),
          this.translate.instant('candidate'),
          this.translate.instant('attendance'),
          this.translate.instant('application'),
          this.translate.instant('allocation'),
          this.translate.instant('contract'),
		  this.translate.instant('planning'),
		  this.translate.instant('mission'),

          this.translate.instant('employee setting'),
          this.translate.instant('application status'),
          this.translate.instant('degree'),
          this.translate.instant('department'),
          this.translate.instant('departure reason'),
          this.translate.instant('employment type'),
          this.translate.instant('experience type'),
          this.translate.instant('mandatory days'),
          this.translate.instant('motif'),
          this.translate.instant('permission type'),
          this.translate.instant('position'),
          this.translate.instant('public holidays'),
          this.translate.instant('rank'),
          this.translate.instant('refuse reason'),
          this.translate.instant('skills'),
          this.translate.instant('source'),
          this.translate.instant('tag'),
          this.translate.instant('time off type'),
          this.translate.instant('work level'),
          this.translate.instant('work location'),
          this.translate.instant('work place'),
          this.translate.instant('working hour'),
          this.translate.instant('working schedule'),
          this.translate.instant('activity type'),
          this.translate.instant('activity plan'),
          this.translate.instant('accrual plan'),

          // Time off module
          
          this.translate.instant('time off'),
          this.translate.instant('time off module'),
          this.translate.instant('time off type'),
		  this.translate.instant('accrual plan'),
		  this.translate.instant('public holiday'),
		  this.translate.instant('mandatory day'),
		  

		  // Payroll module
      this.translate.instant('payroll module'),
          this.translate.instant('hr module'),
		  
		  this.translate.instant('hr setting'),
		  this.translate.instant('salary category'),
		  this.translate.instant('echellon'),
		  this.translate.instant('salary scale'),
		  this.translate.instant('advantage type'),
		  this.translate.instant('deduction type'),
		  this.translate.instant('hr partner'),
		  
		  this.translate.instant('scale'),
		  this.translate.instant('calculation scale'),
		  this.translate.instant('scale range'),
		  this.translate.instant('calculation basis'),
		  this.translate.instant('advantage'),
		  this.translate.instant('advantage element'),
		  this.translate.instant('deduction'),
		  this.translate.instant('deduction element'),
		  this.translate.instant('by advantage'),
		  this.translate.instant('by deduction'),
		  this.translate.instant('by contract'),
		  
		  this.translate.instant('salary simulation'),
		  this.translate.instant('validated salary'),
		  this.translate.instant('report'),
		  this.translate.instant('simulated payslip'),
		  this.translate.instant('validated payslip'),

          // fleet module
          this.translate.instant('fleet module'),

		  this.translate.instant('fleet setting'),
          this.translate.instant('fuel type'),
          this.translate.instant('manufacturer'),
          this.translate.instant('vehicle model'),
          this.translate.instant('power unit'),
          this.translate.instant('service type'),
          this.translate.instant('vehicle category'),

          this.translate.instant('vehicle'),
          this.translate.instant('odometer'),
          this.translate.instant('fleet service'),
          this.translate.instant('fleet contract'),

          // Appointment module
          this.translate.instant('appointment module'),
          this.translate.instant('appointment'),

          // Expense module
          this.translate.instant('expense module'),
          this.translate.instant('expense category'),
          this.translate.instant('expense'),
		  
		  // Shipment

      this.translate.instant('shipment module'),
          this.translate.instant('parcel category'),
          this.translate.instant('collection point'),
          this.translate.instant('shipment area'),

          // Report
          this.translate.instant('stock menu'),
          this.translate.instant('stock list'),
          this.translate.instant('stock movement history'),
          this.translate.instant('stock valuation'),
          this.translate.instant('stock exportation'),
          this.translate.instant('stock quantity'),
          this.translate.instant('stock history'),

          this.translate.instant('treasury menu'),
          this.translate.instant('cash desk history'),
          this.translate.instant('bank account history'),
          this.translate.instant('main cash desk history'),

          this.translate.instant('sale menu'),
          this.translate.instant('sale invoice'),
          this.translate.instant('sale return invoice'),
          this.translate.instant('sale settlement'),
          this.translate.instant('sale payment history'),
          this.translate.instant('sale refund history'),
          this.translate.instant('item quantity sold'),
          this.translate.instant('total sale per branch'),

          this.translate.instant('purchase menu'),
          this.translate.instant('purchase invoice'),
          this.translate.instant('purchase return invoice'),
          this.translate.instant('purchase settlement'),
          this.translate.instant('purchase payment history'),
          this.translate.instant('purchase refund history'),

          this.translate.instant('budget menu'),
          this.translate.instant('budget expense'),
          this.translate.instant('budget income'),
          this.translate.instant('budget income and expense'),
          this.translate.instant('budget transaction'),
          this.translate.instant('budget transaction with sector'),

          this.translate.instant('production menu'),
          this.translate.instant('sale summary production'),
          this.translate.instant('weekly sale summary production'),

          this.translate.instant('time off'),
          this.translate.instant('time off analysis by employee'),
          this.translate.instant('time off left by type'),


          this.translate.instant('account plan'),

          this.translate.instant('sav module'),
          this.translate.instant('accounting module',)

      ];

  // For Horizontal Menu
  public margin: any = 0;
  public width: any = window.innerWidth;
  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;

  constructor(private router: Router, public navServices: NavService, private sharedDataService: SharedDataService,
              private menuService: MenuService,
              public layout: LayoutService, public translate: TranslateService) {

    // this.navServices.items.subscribe(menuItems => {
    //   this.menuItems = menuItems;
    //   console.log(menuItems);
    //   this.router.events.subscribe((event) => {
    //     // console.log(event);
    //     if (event instanceof NavigationEnd) {
    //       menuItems.filter(items => {
    //         console.log(items);
    //         if (items.path === event.url) {
    //           this.setNavActive(items);
    //         }
    //         if (!items.children) { return-invoice false; }
    //         items.children.filter(subItems => {
    //           if (subItems.path === event.url) {
    //             this.setNavActive(subItems);
    //           }
    //           if (!subItems.children) { return-invoice false; }
    //           subItems.children.filter(subSubItems => {
    //             if (subSubItems.path === event.url) {
    //               this.setNavActive(subSubItems);
    //             }
    //           });
    //         });
    //       });
    //     }
    //   });
    // });



  }

    ngOnInit(): void {

        const moduleId = localStorage.getItem('moduleId');
        this.checkProfile = JSON.parse(localStorage.getItem('user'))['profile'];
        this.navServices.loadMenu(moduleId).subscribe(menuItems  => {
                console.log(menuItems.modules);
                const datas = menuItems.modules;
                // const type = datas.type;
                // const objt: any = {};

                this.menuItems = datas.map((m) => {
                    // if (type === 'link'){
                    if (window.location.pathname == m.path){

                        this.menuService.getPermissionsByMenuId(m.id).subscribe({
                            next: (data: any) => {
                                console.log(data['hydra:member'])
                                this.userPermissions = data['hydra:member'];

                                this.sharedDataService.setPermissions(data['hydra:member']);
                            },
                            error:(err: HttpErrorResponse) =>{
                                console.log(err);
                            }
                        });
                    }

                    return {
                        id: m.id,
                        icon : m.icon,
                        path : m.path,
                        title : m.name,
                        type : m.type,
                        // bookmark: v.bookmark

                        children: m.children?.map((v: any) => {

                            if (window.location.pathname == v.path){
                                this.menuService.getPermissionsByMenuId(v.id).subscribe({
                                    next: (data: any) => {
                                        console.log(data['hydra:member'])
                                        this.userPermissions = data['hydra:member'];

                                        this.sharedDataService.setPermissions(data['hydra:member']);
                                    },
                                    error:(err: HttpErrorResponse) =>{
                                        console.log(err);
                                    }
                                });
                            }

                            return {
                                id: v.id,
                                path : v.path,
                                title : v.name,
                                type : v.type
                            };


                        })

                    };

                });
            },
        );

  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = event.target.innerWidth - 500;
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  // Active Nave state
  setNavActive(item) {
    this.menuItems.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }


  // For Horizontal Menu
  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3051) {
      this.margin = -3464;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('ngOnChanges', changes);
    this.menuItems = changes.menuItems.currentValue;
    this.router.events.subscribe((event) => {
      // console.log(event);
      if (event instanceof NavigationEnd) {
        this.menuItems.filter(items => {
          console.log(items);
          if (items.path === event.url) {
            this.setNavActive(items);
          }
          if (!items.children) { return false; }
          items.children.filter(subItems => {
            if (subItems.path === event.url) {
              this.setNavActive(subItems);
            }
            if (!subItems.children) { return false; }
            subItems.children.filter(subSubItems => {
              if (subSubItems.path === event.url) {
                this.setNavActive(subSubItems);
              }
            });
          });
        });
      }
    });
  }

    menuClick(menu: any): void {
        console.log(menu);
        if (menu.path == '/billing/sale-invoice'){
            console.log('mouff dion1')
            localStorage.removeItem('perms')
        }

        this.menuService.getPermissionsByMenuId(menu.id).subscribe({
            next: (data: any) => {
                console.log(data['hydra:member'])
                this.userPermissions = data['hydra:member'];

                this.sharedDataService.setPermissions(data['hydra:member']);
            },
            error:(err: HttpErrorResponse) =>{
                console.log(err);
            }
        });
    }

}
